import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

const useSignalR = (hubUrl, eventHandlers) => {
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    setConnection(newConnection);

    return () => {
      if (newConnection) {
        newConnection.stop();
      }
    };
  }, [hubUrl]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          for (const [event, handler] of Object.entries(eventHandlers)) {
            connection.on(event, handler);
          }
        })
        .catch((error) => console.error('Connection failed: ', error));
    }

    return () => {
      if (connection) {
        for (const event of Object.keys(eventHandlers)) {
          connection.off(event, eventHandlers[event]);
        }
      }
    };
  }, [connection, eventHandlers]);

  return connection;
};

export default useSignalR;
